// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"24":"e5273350","287":"08fe2a49","402":"3a65f26d"}[chunkId] + ".chunk.js");